import {Rule} from "./types";

type FilterRulesProps = {
  rules: Rule[];
  searchTerm: string;
};

export const filterRules = ({rules, searchTerm}: FilterRulesProps) => {
  return rules.filter((rule) => {
    const keywordString = rule.match.keywords.join(",");
    return keywordString.includes(searchTerm);
  });
};
